import type { ApiBody, ApiQuery } from '../../../shared/api/contracts'
import type { Expense } from '../../../shared/api/models'
import { apiGet, apiPost, apiPut, apiDelete } from './transport'
import { getApiWorkspaceId } from './workspaceState'

export async function fetchExpenses(params: ApiQuery<'GET /admin/expenses'>, signal?: AbortSignal) {
  const u = new URLSearchParams()
  u.set('limit', String(params.limit))
  u.set('offset', String(params.offset))
  if (params.q) u.set('q', params.q)
  if (params.userId != null) u.set('userId', String(params.userId))
  if (params.dateFrom) u.set('dateFrom', String(params.dateFrom))
  if (params.dateTo) u.set('dateTo', String(params.dateTo))
  if (params.category) u.set('category', String(params.category))
  if (params.sort) u.set('sort', params.sort)
  for (const name of ['onlyOther', 'onlyNeedsAttention', 'onlyNoComment', 'exportMode'] as const) if (params[name]) u.set(name, 'true')
  for (const name of ['minAmount', 'maxAmount', 'exportVersion'] as const) if (params[name] != null) u.set(name, String(params[name]))
  return apiGet<'GET /admin/expenses'>(`/admin/expenses?${u.toString()}`, signal)
}

export async function fetchAllExpenses(params: Omit<Parameters<typeof fetchExpenses>[0], 'limit' | 'offset'>, signal?: AbortSignal) {
  const items: Expense[] = []
  const workspace = getApiWorkspaceId()
  for (let page = 0; page < 100; page += 1) {
    if (getApiWorkspaceId() !== workspace) throw new Error('Бюджет изменён. Обновите данные.')
    const response = await fetchExpenses({ ...params, limit: 200, offset: page * 200 }, signal)
    items.push(...response.items)
    if (!response.hasMore) return { ok: true as const, items }
  }
  throw new Error('Слишком много операций. Выберите более короткий период.')
}

export async function fetchExpense(id: string, signal?: AbortSignal) {
  return apiGet<'GET /admin/expenses/:id'>(`/admin/expenses/${encodeURIComponent(id)}`, signal)
}

export async function createExpense(payload: ApiBody<'POST /admin/expenses'>, signal?: AbortSignal) {
  return apiPost<'POST /admin/expenses'>('/admin/expenses', payload, signal)
}

export async function updateExpenseItem(
  expenseId: string,
  itemId: string,
  payload: ApiBody<'PUT /admin/expenses/:eid/items/:itemId'>, signal?: AbortSignal
) {
  return apiPut<'PUT /admin/expenses/:eid/items/:itemId'>(`/admin/expenses/${encodeURIComponent(expenseId)}/items/${encodeURIComponent(itemId)}`, payload, signal)
}

export async function deleteExpenseItem(expenseId: string, itemId: string, signal?: AbortSignal) {
  return apiDelete<'DELETE /admin/expenses/:id/items/:itemId'>(`/admin/expenses/${encodeURIComponent(expenseId)}/items/${encodeURIComponent(itemId)}`, signal)
}
